import React,{ useState } from 'react';
import { DateRangePickerWrapper } from 'components/Date/DateRangePicker';
import styles from '../refund-report/index.module.scss';
import moment from 'moment';
import ActionButton from 'components/ActionButton';


const Filters = props =>{
  const [startDate, setStartDate] = useState<string>(moment().subtract(3, 'month').toISOString());
  const [endDate, setEndDate] = useState<string>(moment().toISOString());
  const [filters, setFilters] = useState<Record<string, string>>({ discountCode: '', user: '' });
  const { onSubmit } = props;

  const handleLocalFilter = (key, val) => {
    const localFilters = { ...filters };
    localFilters[key] = val;
    setFilters(localFilters);
  };

  const onDateSelectionChange = ({ startDate, endDate }: { startDate: Date; endDate: Date }) => {
    setStartDate(moment(startDate).toISOString());
    setEndDate(moment(endDate).toISOString());
  };
    
  return(
    <div className="d-flex justify-content-between">
      <div className={styles['filter-container']}>
        <div>
          <div className={styles['label']}>Date Range</div>
          <DateRangePickerWrapper
            disabled={false}
            startDate={startDate}
            endDate={endDate}
            onDatesChange={onDateSelectionChange}
            // onFocusChange={()=>fetchDiscountRedemptionFn()}
          />
        </div>
        <div>
          <div className={styles['label']}>Discount Code</div>
          <input
            type={'text'}
            placeholder={'Search Discount Code'}
            onChange={(e) => handleLocalFilter('discountCode', e.target.value)}
            style={{ paddingLeft: '10px' }}
          />
        </div>
        <div>
          <div className={styles['label']}>User</div>
          <input
            type={'text'}
            placeholder={'Search User'}
            onChange={(e) => handleLocalFilter('user', e.target.value)}
            style={{ paddingLeft: '10px' }}
          />
        </div>
      </div>
      <div className="align-self-center mr-3">
        <ActionButton
          text={'Submit'}
          active={true}
          isLoading={false}
          onClick={()=>onSubmit({ startDate, endDate, ...filters })}
        />
      </div>
    </div>
  );
};
export default Filters;